import { SET_SOURCE_INTEGRATIONS_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_SOURCE_INTEGRATIONS_SETTINGS, {
  searchTerm: '',
  isSherlockOpen: false
})



// WEBPACK FOOTER //
// ./reducers/application/source-integrations.js